import {
  agentCreationTokenMesaages,
  tokenFilterOptions,
  tokenReducerMessage,
} from '../../constants/app.constants';
import { tokenActionTypes as ACTION } from '../actionTypes';

const initialState = {
  loading: false,
  error: '',
  tokenDetails: {
    data: {},
    message: '',
  },
  copyDetails: {
    message: '',
  },
  tokens: {
    data: {},
    message: '',
  },
  tokenDeleteData: {
    data: null,
    message: '',
  },
  filter: {
    [tokenFilterOptions.Company]: [],
    [tokenFilterOptions.Status]: [],
    [tokenFilterOptions.Type]: [],
  },
};

const TokenReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.FETCH_TOKEN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ACTION.CREATE_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        tokenDetails: {
          data: action.payload.token,
          message: agentCreationTokenMesaages.tokenCreatedSuccessfully,
        },
      };
    case ACTION.REMOVE_TOKEN_DETAILS:
      return {
        ...state,
        loading: false,
        tokenDetails: {
          data: {},
          message: {},
        },
      };
    case ACTION.REMOVE_CREATE_TOKEN_SUCCESS_MESSAGE:
      return {
        ...state,
        loading: false,
        tokenDetails: {
          ...state.tokenDetails,
          message: '',
        },
      };
    case ACTION.CREATE_TOKEN_FAILURE:
      return {
        ...state,
        loading: false,
        tokenDetails: {
          ...state.tokenDetails,
        },
        error: action.payload.message,
      };
    case ACTION.SET_TOKEN_ERROR:
      return {
        ...state,
        loading: false,
        tokenDetails: {
          ...state.tokenDetails,
        },
        error: action.payload,
      };
    case ACTION.REMOVE_TOKEN_ERROR:
      return {
        ...state,
        loading: false,
        tokenDetails: {
          ...state.tokenDetails,
        },
        error: '',
      };
    case ACTION.SET_TOKEN_COPIED_MESSAGE:
      return {
        ...state,
        copyDetails: {
          ...state.copyDetails,
          message: tokenReducerMessage.tokenCopied,
        },
      };
    case ACTION.REMOVE_TOKEN_COPIED_MESSAGE:
      return {
        ...state,
        copyDetails: {
          ...state.copyDetails,
          message: '',
        },
      };
    case ACTION.TOKEN_START_FETCH:
      return {
        ...state,
        loading: true,
      };
    case ACTION.FETCH_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        tokens: {
          ...state.tokens,
          data: action.payload,
          message: '',
        },
        error: '',
      };
    case ACTION.FETCH_TOKEN_FAILURE:
      return {
        ...state,
        loading: false,
        tokens: {
          ...state.tokens,
          data: {},
        },
        error: action.payload,
      };
    case ACTION.DELETE_REGISTRATION_TOKEN_SUCCESS:
      const { data, message } = action.payload;
      return {
        ...state,
        loading: false,
        tokenDeleteData: {
          ...state.tokenDeleteData,
          data: data,
          message: message,
        },
      };
    case ACTION.DELETE_REGISTRATION_TOKEN_FAILURE:
      return {
        ...state,
        loading: false,
        tokenDeleteData: {
          ...state.tokenDeleteData,
        },
        error: action.payload,
      };
    case ACTION.REMOVE_DELETE_TOKEN_DATA_SUCCESS_MESSAGE:
      return {
        ...state,
        loading: false,
        tokenDeleteData: {
          ...state.tokenDeleteData,
          message: '',
        },
      };
    case ACTION.TOKEN_FILTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case ACTION.TOKEN_FILTER_SUCCESS:
      const { key, values } = action.payload;
      return {
        ...state,
        loading: false,
        filter: {
          ...state.filter,
          [key]: [...values],
        },
      };
    case ACTION.TOKEN_FILTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
export default TokenReducer;
